import { GridColDef } from "@mui/x-data-grid";
import DocumentTemplate from "../interfaces/documentTemplate";
import { Typography } from "@mui/material";

const getDocumentTemplateColumnDef = (): GridColDef<DocumentTemplate>[] => [
  {
    field: "thumbnail_url",
    headerName: "Thumbnail",
    width: 90,
    renderCell: (params) => {
      const url = params.value;
      if (!url) return null;
      return (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none", color: "#1976d2", wordBreak: "break-all" }}
        >
          <Typography variant="body2">{url}</Typography>
        </a>
      );
    },
  },
  {
    field: "template_name",
    headerName: "Template Name",
    width: 240,
  },
  {
    field: "template_type",
    headerName: "Template Type",
    width: 200,
    renderCell: (params) => {
      const type = params.value;
      if (!type) return <Typography variant="body2" color="text.secondary">-</Typography>;
      const displayName = type === "Notice" 
        ? "Notice" 
        : type === "AgentAuthorizationDocument"
        ? "Agent Authorization Document"
        : type;
      return <Typography variant="body2">{displayName}</Typography>;
    },
  },
  {
    field: "signed_url",
    headerName: "Template URL",
    width: 240,
    renderCell: (params) => {
      const url = params.value;
      if (!url) return null;
      return (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none", color: "#1976d2", wordBreak: "break-all" }}
        >
          <Typography variant="body2">{url}</Typography>
        </a>
      );
    },
  },
  { field: "created_by", headerName: "Created By", width: 140 },
  {
    field: "created_date",
    headerName: "Created Date",
    width: 180,
  },
  { field: "updated_by", headerName: "Updated By", width: 140 },
  {
    field: "updated_date",
    headerName: "Updated Date",
    width: 180,
  },
];

export default getDocumentTemplateColumnDef;
